<template>
    <div>
        <div class="layer-content">
            <fileupload ref="fileList"
                        :formse="'dragAndBtn'"
                        :filelist="fileList"
                        :maxcnt="20"
                        :maxsize="100"
                        :cdn-at="'Y'"
                        :setbasepath="'ongw/'"
                        :extsns="'gif,jpg,doc,xls,ppt,pdf,txt,xlsx,png,pptx,docx,jpeg,zip,hwp,bmp'"
                        :setstorge="'myPage/' + mberInfo.mberNo + '/attach/' + dayInfo.ymd + '/'">
            </fileupload>
        </div>
        <div class="btn-wrap layer-btn" style="border-top:1px solid #e0e0e0;">
            <div style="width:50%">
                <button class="_bt-blue" style="width:100%" @click="saveI5gamExlFile()"><span>업로드</span></button>
            </div>
            <div style="width:50%">
                <button style="width:100%" @click="closePopup()"><span>취소</span></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'uploadContractPopup',
    props : ['param', 'popupIndex'],
    data : function(){
        return {
            orderInfo : null,
            fcltcd : '',
            fileList : new Array()
        }
    },
    methods : {
        searchContractFileList : function(){
            const _this = this;
            this.axios.post('/i5gam/srvc/searchContractFileList.act',{
                reqstSn : this.orderInfo.reqstSn,
                orderSn : this.orderInfo.orderSn,
                fcltcd : this.fcltcd,
            }).then(function(response) {
                this.fileList = response.data.fileList;
            }.bind(this)).catch(function(e) {
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        },
        validChk : function(){
            const fileList = this.fileList.filter(function(info){
                return info.fileSe != 'DEL';
            });

            if(fileList.length == 0){
                this.$toasted.show("업로드할 파일을 첨부해주세요.");
                return true;
            }

            return false;
        },
        saveI5gamExlFile : function(){
            if(this.validChk()) return false;

            const _this = this;
            this.axios.post('/i5gam/srvc/saveI5gamExlFile.act',{
                reqstSn : this.orderInfo.reqstSn,
                orderSn : this.orderInfo.orderSn,
                fileGrpCd : this.orderInfo.fileGrpCd,
                fcltcd : this.fcltcd,
                fileList : this.fileList,
                mberNo : this.mberInfo.mberNo,
            }).then(function(response) {
                const procInfo = response.data.procInfo;
                if(procInfo.procCode == '000'){
                    _this.$toasted.show('업로드가 완료되었습니다.',{duration:1000,type:"success"});
                    _this.param.callBackFunc();
                    _this.$store.commit('closePopup', this.popupIndex);
                }
            }.bind(this)).catch(function(e) {
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        },
        closePopup : function(){
            this.$store.commit('closePopup');
        }
    },
    mounted : function(){
        this.orderInfo = this.param.orderInfo;
        this.fcltcd = this.param.fcltcd;
        this.searchContractFileList();
    },
    computed : {
        mberInfo : function(){
            return this.$store.getters.getMberInfo;
        },
        dayInfo: function(){
            return this.$store.getters.getDayInfo;
        },
    }
}
</script>